import { SEC_ApiCall, SEC_DataApiPost } from '../../func.js';

/** Convert numeric style values that legacy DynamoDB responses serialised as strings. */
function normaliseTemplateNumbers(template) {
    if (!template || typeof template !== 'object') return template;
    return {
        ...template,
        version: Number(template.version),
        rows: (template.rows || []).map(row => ({
            ...row,
            columns: (row.columns || []).map(column => ({
                ...column,
                blocks: (column.blocks || []).map(block => ({
                    ...block,
                    padding: Object.fromEntries(['top', 'right', 'bottom', 'left'].map(side => [side, Number(block.padding?.[side] || 0)])),
                    ...(block.type === 'text' ? { fontSize: Number(block.fontSize) } : {}),
                    ...(block.type === 'image' ? { width: Number(block.width) } : {}),
                    ...(block.type === 'spacer' ? { height: Number(block.height) } : {}),
                })),
            })),
        })),
    };
}

/** Load the current school signature after the API rechecks live access. */
export async function getEmailSignatureTemplate() {
    const response = await SEC_ApiCall('tools/email-signature/config');
    if (!response || response.message || (response.template !== null && typeof response.template !== 'object')) throw new Error('Invalid signature configuration.');
    return normaliseTemplateNumbers(response.template);
}

/** Save a validated declarative template for this school. */
export async function saveEmailSignatureTemplate(template) {
    // Always send the current numeric schema version, including after loading legacy data.
    const canonicalTemplate = { ...template, version: 1 };
    const response = await SEC_DataApiPost('sysmanager/tools/email-signature/config', JSON.stringify({ template: canonicalTemplate }), {});
    if (!response || response.message || typeof response.template !== 'object') throw new Error('Saved signature configuration could not be confirmed.');
    return response.template;
}
